import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import Helmet from 'react-helmet';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Table from 'react-bootstrap/lib/Table';
import Button from 'react-bootstrap/lib/Button';
import Confirm from 'react-confirm-bootstrap';
import { getAllPaymentRecords, getPaymentRecord } from '../redux/modules/paymentRecord';
import { createVoid, getVoid } from '../redux/modules/void';

const PAID_PRE_REPORTED_TO_FOUR_D = 'PAID_PRE_REPORTED_TO_FOUR_D';
const PAID_REPORTED_TO_FOUR_D = 'PAID_REPORTED_TO_FOUR_D';
const PAID_FAILED_4D_REPORT_THEN_VOIDED = 'PAID_FAILED_4D_REPORT_THEN_VOIDED';

export class ManagePayments extends Component {
  static propTypes = {
    payments: PropTypes.array,
    user: PropTypes.object,
    getAllPaymentRecords: PropTypes.func.isRequired,
    getPaymentRecord: PropTypes.func.isRequired,
    createVoid: PropTypes.func.isRequired,
    getVoid: PropTypes.func.isRequired,
  };

  static defaultProps = {
    payments: [],
    user: null,
  };

  constructor() {
    super();
    this.state = {
      showConfirmationModal: false,
      paymentToVoid: null,
    };
    this.sendVoidConfirmation = this.sendVoidConfirmation.bind(this);
    this.handleVoidConfirmationApproval = this.handleVoidConfirmationApproval.bind(this);
    this.handleVoidConfirmationRejection = this.handleVoidConfirmationRejection.bind(this);
  }

  componentWillMount() {
    const { getAllPaymentRecords } = this.props;
    getAllPaymentRecords();
  }

  mapStatus(status) {
    if (this.isUserAdmin()) {
      return status || 'VOIDED';
    } else {
      return (
        {
          [PAID_PRE_REPORTED_TO_FOUR_D]: 'PAID',
          [PAID_REPORTED_TO_FOUR_D]: 'PAID',
          [PAID_FAILED_4D_REPORT_THEN_VOIDED]: 'VOIDED',
        }[status] || 'VOIDED'
      );
    }
  }

  isUserAdmin() {
    const { user } = this.props;
    return _.get(user, 'dealerRel.dealerAdmin') || _.get(user, 'dealerRel.prcoAdmin');
  }

  handleVoid = (payment) => {
    const paymentId = payment._id;
    const token = _.get(payment, 'sageDetails.token');
    const companyName = _.get(payment, 'billingDetails.companyName', 'UNKNOWN');
    const amount = _.get(payment, 'paymentDetails.amount');

    const { createVoid } = this.props;

    if (paymentId && token && companyName && amount) {
      return createVoid({
        paymentId,
        token,
        companyName,
        amount,
      });
    }
  };

  handleVoidDownload = ({ _id, dealerId }) => this.props.getVoid({ dealerId, paymentId: _id });

  handlePaymentDownload = ({ _id }) => this.props.getPaymentRecord(_id);

  resetConfirmationModal = () =>
    this.setState(() => ({ showConfirmationModal: false, paymentToVoid: null }));

  handleVoidConfirmationApproval = () => {
    this.handleVoid(this.state.paymentToVoid);
    this.resetConfirmationModal();
  };

  handleVoidConfirmationRejection = () => this.resetConfirmationModal();

  sendVoidConfirmation = (payment) =>
    this.setState(() => ({ showConfirmationModal: true, paymentToVoid: payment }));

  render() {
    const { payments } = this.props;
    const { showConfirmationModal } = this.state;

    return (
      <div>
        <Helmet title="Payment Administration" />
        <Grid>
          <Row>
            <Col xs={12}>
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>Created</th>
                    <th>Dealer ID</th>
                    <th>Amount</th>
                    {this.isUserAdmin() ? <th>Token</th> : null}
                    <th>Status</th>
                    <th>&nbsp;</th>
                    {this.isUserAdmin() ? <th>&nbsp;</th> : null}
                  </tr>
                </thead>
                <tbody>
                  {_.map(payments, (payment, idx) => {
                    const created = moment(payment.created).format('MMM Do YYYY, h:mm:ss a');
                    const token = _.get(payment, 'sageDetails.token');
                    return (
                      <tr key={idx} style={payment.voided ? { color: 'red' } : undefined}>
                        <td>{created}</td>
                        <td>{payment.dealerId}</td>
                        <td>
                          {numeral(_.get(payment, 'paymentDetails.amount')).format('$0,0.00')}
                        </td>
                        {this.isUserAdmin() ? <td>{token}</td> : null}
                        <td>{this.mapStatus(_.get(payment, 'status'))}</td>
                        <td>
                          {!payment.voided && token ? (
                            <Button
                              bsStyle="primary"
                              onClick={_.partial(this.sendVoidConfirmation, payment)}
                              block
                            >
                              Void
                            </Button>
                          ) : this.isUserAdmin() ? (
                            <Button
                              bsStyle="default"
                              onClick={_.partial(this.handleVoidDownload, payment)}
                              block
                            >
                              Download Void
                            </Button>
                          ) : null}
                        </td>
                        {this.isUserAdmin() ? (
                          <td>
                            <Button
                              bsStyle="default"
                              onClick={_.partial(this.handlePaymentDownload, payment)}
                              block
                            >
                              Download Payment
                            </Button>
                          </td>
                        ) : null}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
        {showConfirmationModal ? (
          <Confirm
            onConfirm={this.handleVoidConfirmationApproval}
            onClose={this.handleVoidConfirmationRejection}
            body={`Are you sure you would like to void this payment?`}
            confirmText={`Void Payment`}
            title="Confirm Void Payment"
            confirmBSStyle="primary"
            visible={true}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    payments: state.paymentRecord.list,
    user: state.auth.user,
  }),
  {
    getAllPaymentRecords,
    getPaymentRecord,
    createVoid,
    getVoid,
  },
)(ManagePayments);
